import React from 'react';
import CapacityElectricityDTO from "features/contracts/dtos/CapacityElectricityDTO";
import { useTranslation } from 'react-i18next';
import NumberFormatter from 'features/shared/components/formatters/NumberFormatter';
import CapacityTypeLabel from './CapacityTypeLabel';
import styles from './reservedCapacity.module.scss';

type Props = {
  capacity: CapacityElectricityDTO;
}

const ReservedCapacityElectricityDraftYearly = ({ capacity }: Props) => {
  // translations
  const tLabels = useTranslation(["contracts\\contracts"]).t;

  // sub-renders
  const renderNumber = (amount: number) => {
    return (
      <>
        <NumberFormatter amount={amount} decimalPlaces={3} />
        <span className="d-sm-none small"> MW</span>
      </>
    );
  };

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className={`col-sm-auto mb-1 mb-sm-0 ${styles.periodCol}`}>
        <div className="d-flex d-sm-block justify-content-between">
          <div className="d-sm-none text-muted pr-2">
            {tLabels("reservedCapacityElectricity.timePeriod")}
          </div>
          <div>
            {capacity.month}/{capacity.year}
          </div>
        </div>
      </div>
      <div className="col-sm text-center mb-1 mb-sm-0">
        <div className="d-flex d-sm-block justify-content-between">
          <div className="d-sm-none text-muted pr-2">
            {tLabels("reservedCapacityElectricity.reservedPower")}
          </div>
          <div>
            {renderNumber(capacity.reserverPower!)}
          </div>
        </div>
      </div>
      <div className="col-sm text-center mb-1 mb-sm-0">
        <div className="d-flex d-sm-block justify-content-between">
          <div className="d-sm-none text-muted pr-2">
            {tLabels("reservedCapacityElectricity.yearlyCapacity")}
          </div>
          <div>
            {renderNumber(capacity.yearlyCapacity!)}
          </div>
        </div>
      </div>
      <div className={`col-sm-auto mb-1 mb-sm-0 text-right ${styles.typeCol}`}>
        <div className="d-flex d-sm-block justify-content-between">
          <div className="d-sm-none text-muted pr-2">
            {tLabels("reservedCapacityElectricity.state")}
          </div>
          <div>
            <CapacityTypeLabel type={capacity.type!} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReservedCapacityElectricityDraftYearly;